import { render, staticRenderFns } from "./ForumChatThreadCardHeader.vue?vue&type=template&id=60164e7a&scoped=true"
import script from "./ForumChatThreadCardHeader.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardHeader.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardHeader.vue?vue&type=style&index=0&id=60164e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60164e7a",
  null
  
)

export default component.exports